import { EVENT_CATEGORIES, HIT_TYPE, EVENT_NAMES } from 'app-webtech-core/beacon/const';

/**
 * Fires when the User selects a section from the L1 navigation bar.
 * There are 3 sections currently - ""live"", ""vod"" and ""settings"".
 * The section that is currently active (last selected by the User)
 * should be populated in the section field.
 */

export const sectionSelectBeacon = ({ payload }) => {
  const { section, previousSection, doNotTrack = false } = payload;

  if (!doNotTrack) {
    return {
      hitType: HIT_TYPE.EVENT,
      eventCategory: EVENT_CATEGORIES.BROWSE,
      eventName: EVENT_NAMES.SECTION_SELECT,
      label: section,
      section,
      previousSection,
    };
  }
  return undefined;
};
